import { Breakpoint, Color, FontWeight, ShapeVariant, TypographyVariant } from '@elearning-platform/ui';
import React from 'react';
import { TransProps, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { ContentContainer, Image, StyledModule, StyledShape, StyledTitle, TextContainer, Wrapper } from './moduleDividerSlide.styled';
import { ModuleDividerSlideProps } from './moduleDividerSlide.types';

export const ModuleDividerSlide: React.FC<ModuleDividerSlideProps> = (props: ModuleDividerSlideProps): JSX.Element => {
  const { baseUrl, data, moduleNumber }: ModuleDividerSlideProps = props;
  const { t }: TransProps<never> = useTranslation();
  const isSmallDesktop: boolean = useMediaQuery({
    query: Breakpoint.SmallDesktop,
  });

  return (
    <Wrapper>
      <ContentContainer>
        <StyledModule fontWeight={FontWeight.Bold} variant={TypographyVariant.TextLG}>
          {t('competence.app.interactions.timerSlides.componentsV2.moduleDividerSlide.module', { moduleNumber })}
        </StyledModule>
        <TextContainer>
          <StyledTitle variant={isSmallDesktop ? TypographyVariant.DisplayXL : TypographyVariant.DisplaySM}>
            {data.title}
          </StyledTitle>
        </TextContainer>
      </ContentContainer>
      <Image src={isSmallDesktop ? baseUrl + data.desktopImage : baseUrl + data.mobileImage} />
      <StyledShape color={Color.Brand100} variant={ShapeVariant.Cage} />
    </Wrapper>
  );
};
